import React, {useCallback, useEffect, useState} from "react";
import Select from "react-select";
import {atom, useAtom} from "jotai";
import styled from "styled-components";
import Table from "../../components/table";
import {dataTotalInfo} from "../../components/common/entity";
import {selAdminList} from "../../services/platform/ManageAdminAxios";
import {columnAdminData, searchAccountInfo, selectAccountUseInfo} from "./entity/common";
import CreateAdminModal from "../../components/common/CreateAdminModal";
import PlatformSectionHeader from "./PlatformSectionHeader";
import PlatformTableBody from "./PlatformTableBody";
import SelectAdminModal from "../../components/common/SelectAdminModal";
import {
  ButtonGroup as Actions,
  ConditionBody,
  ConditionFooter as Footer,
  FieldLabel as Label,
  HeaderAddAction as AddAction,
  PageLayout as Page,
  PrimaryButton as ApplyButton,
  SecondaryButton as ResetButton,
  StatusTag,
  SurfaceCard as Card
} from "../../components/common/PageStyles";

const AdminListAtom=atom([]);
const selectStyle={
  control:(b,s)=>({...b,minHeight:42,height:42,borderColor:s.isFocused?"var(--theme-primary)":"#dfe3e7",borderRadius:8,boxShadow:s.isFocused?"0 0 0 3px var(--theme-primary-focus-ring)":"none",fontSize:11,"&:hover":{borderColor:"var(--theme-primary-border)"}}),
  valueContainer:b=>({...b,height:42,padding:"0 12px"}),indicatorsContainer:b=>({...b,height:42}),indicatorSeparator:()=>({display:"none"}),
  menu:b=>({...b,zIndex:40,overflow:"hidden",borderRadius:8}),option:(b,s)=>({...b,background:s.isSelected?"var(--theme-primary-soft)":s.isFocused?"var(--theme-primary-softest)":"#fff",color:s.isSelected?"var(--theme-primary-strong)":"#555",fontSize:11})
};

export default function PlatformAdmin(){
  const [open,setOpen]=useState(false);
  const [search,setSearch]=useState({...searchAccountInfo});
  const [list,setList]=useAtom(AdminListAtom);
  const [total,setTotal]=useState(dataTotalInfo);
  const fetchList=useCallback(async condition=>{
    const response=await selAdminList(condition);
    setList(response?.content||[]);
    setTotal({totalCount:response?.totalElements||0,totalPages:response?.totalPages||0,currentPage:response?.pageNumber||0});
  },[setList]);
  useEffect(()=>{fetchList(searchAccountInfo);},[fetchList]);
  const reset=()=>{const next={...searchAccountInfo};setSearch(next);fetchList(next);};
  const adminColumns=[
    {
      ...columnAdminData.find(column=>column.name==="status"),
      header:"사용 여부",
      width:100,
      render:({value})=><StatusTag $active={value==="NORMAL"}>{value==="NORMAL"?"활성화":"비활성화"}</StatusTag>
    },
    ...columnAdminData.filter(column=>column.name!=="status").map(column=>column.name==="email"?{
      ...column,
      render:({value,data})=><SelectAdminModal formType="admin" title="관리자 상세 정보" buttonText={value} data={data} onClick={()=>fetchList(search)}/>
    }:column)
  ].filter(Boolean);
  const openDetail=(...args)=>{
    const event=args.find(arg=>arg?.target||arg?.nativeEvent?.target||arg?.event?.target);
    const target=event?.target||event?.nativeEvent?.target||event?.event?.target;
    if(!target?.closest||target.closest("button,a,input,select,[role='button']")) return;
    target.closest(".InovuaReactDataGrid__row")?.querySelector("button")?.click();
  };
  const action=<AddAction><CreateAdminModal formType="admin" title="관리자 추가" buttonText="+ 관리자 추가"/></AddAction>;
  return <Page>
    <Card $open={open}>
      <PlatformSectionHeader title="조회 조건" description="계정 활성화 여부를 기준으로 관리자 목록을 조회합니다." collapsible open={open} onToggle={()=>setOpen(v=>!v)}/>
      {open&&<ConditionBody><Field><Label>활성화 여부</Label><Select styles={selectStyle} options={selectAccountUseInfo} value={selectAccountUseInfo.find(v=>v.value===search.activeYn)||selectAccountUseInfo[0]} onChange={v=>setSearch(p=>({...p,activeYn:v.value}))} isSearchable={false}/></Field>
        <Footer><span>조건을 설정한 뒤 적용 버튼을 눌러 목록을 조회합니다.</span><Actions><ResetButton onClick={reset}>초기화</ResetButton><ApplyButton onClick={()=>fetchList(search)}>적용</ApplyButton></Actions></Footer>
      </ConditionBody>}
    </Card>
    <Card><PlatformSectionHeader title="관리자 목록" description="등록된 관리자 정보와 계정 상태를 확인합니다." count={total.totalCount||0} unit="명" action={action}/>
      <PlatformTableBody><Table columns={adminColumns} data={list||[]} onRowClick={openDetail}/></PlatformTableBody>
    </Card>
  </Page>;
}
const Field=styled.div`display:flex;width:280px;max-width:100%;flex-direction:column;gap:7px;`;
